<template>
	<section class="view-signup-confirmation">
		<header class="stepped-overlay-header">
			<ChalkyBrandingBadge size="md" />

			<section class="user-welcome">
				<ChalkyUserAvatar class="push-bottom" v-bind:userModel="userModel" size="xxxl" />

				<h2>Welcome {{ userModel.getFirstName() }}!</h2>
				<p class="type-large-paragraph">
					We're so excited to have you
					<br />
					join us at ChalkySticks!
				</p>
			</section>
		</header>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Signup
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewSignupConfirmation extends ViewBase {
		/**
		 * @type ChalkySticks.Model.User
		 */
		@Prop()
		protected userModel!: ChalkySticks.Model.User;

		/**
		 * @return void
		 */
		@mounted
		protected setup(): void {
			setTimeout(() => {
				this.$router.replace({ name: 'PageHome' });
			}, 1000 * 2);
		}
	}
</script>

<style lang="scss">
	.view-signup-confirmation {
		.user-welcome {
			left: 50%;
			position: absolute;
			top: 50%;
			transform: translate(-50%, -50%);
			width: 90%;
		}
	}
</style>
